import React from 'react';
import { Check, X } from 'lucide-react';
import type { PodListItem } from '../../services/podsApi';
import './PodCard.css';

interface PodCardProps {
  pod: PodListItem;
  onClick: () => void;
  onAccept?: () => void;
  onDecline?: () => void;
}

const PodCard: React.FC<PodCardProps> = ({ pod, onClick, onAccept, onDecline }) => {
  const activity = pod.recent_activity;
  const isPending = pod.my_status === 'pending';

  return (
    <div className={`pod-card ${isPending ? 'pod-card--pending' : ''}`} onClick={isPending ? undefined : onClick}>
      <div className="pod-card-header">
        <div className="pod-card-avatars">
          {pod.member_previews.slice(0, 4).map((m, i) => (
            <span
              key={m.id}
              className="pod-card-avatar"
              style={{ zIndex: 4 - i }}
              title={m.name}
            >
              {m.initials}
            </span>
          ))}
          {pod.member_count > 4 && (
            <span className="pod-card-avatar pod-card-avatar--overflow">
              +{pod.member_count - 4}
            </span>
          )}
        </div>
        {isPending ? (
          <span className="pod-card-pending-badge">Invitation</span>
        ) : (
          <span className="pod-card-count">{pod.member_count} member{pod.member_count !== 1 ? 's' : ''}</span>
        )}
      </div>
      <h3 className="pod-card-name">{pod.name}</h3>
      {isPending ? (
        <div className="pod-card-pending-actions">
          <button className="pod-card-accept" onClick={(e) => { e.stopPropagation(); onAccept?.(); }}>
            <Check size={14} /> Accept
          </button>
          <button className="pod-card-decline" onClick={(e) => { e.stopPropagation(); onDecline?.(); }}>
            <X size={14} /> Decline
          </button>
        </div>
      ) : (
        <p className="pod-card-activity">
          {activity
            ? `${activity.total_plans} plan${activity.total_plans !== 1 ? 's' : ''} · Last: ${activity.latest_plan_title}`
            : 'No plans yet'}
        </p>
      )}
    </div>
  );
};

export default PodCard;
